export const EMOJI = {
  WINNER: "✔",
  LOSER: "✘",
  //
  UP: "▲",
  DOWN: "▼",

  //

  IN_PLAY: "🏏",
};
